import React from "react";
import "./index.css";

interface LoadingScreenProps {
  title?: string;
  text?: string;
  className?: string;
}

export const LoadingScreen: React.FC<LoadingScreenProps> = ({
  title = "TFTC Member Platform",
  text = "読み込み中…",
  className = "",
}) => {
  return (
    <section className={`loading-screen ${className}`}>
      <div className="loading-brand">
        <h1 className="loading-title">{title}</h1>
      </div>

      {/* Animated loading dots */}
      <div className="loading-dots">
        <div className="loading-dot"></div>
        <div className="loading-dot"></div>
        <div className="loading-dot"></div>
      </div>

      {/* Loading text */}
      <p className="loading-text">{text}</p>
    </section>
  );
};
